import type { AppIconProps } from "../IconTypes";

export const LocalDatabaseIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "72"}
      height={height || "72"}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18C12 22.971 22.746 27 36 27C49.254 27 60 22.971 60 18M12 18C12 13.029 22.746 9 36 9C49.254 9 60 13.029 60 18M12 18V36M60 18V36M12 36C12 40.971 22.746 45 36 45C39.225 45 42.3 44.76 45.111 44.328M12 36V54C12 58.971 22.746 63 36 63C36.498 63 36.993 62.994 37.485 62.982M48 57H66M57 48V66"
        stroke="#7A909C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
